import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sentenceCase' })
export class SentenceCasePipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    
    const str = String(value).trim();

    if (!str) {
      return '';
    }

    const lower = str.toLowerCase();

    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }
}
